var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "chartContainer",
      staticStyle: {
        padding: "0",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      },
      style: _vm.bg_class,
    },
    [
      _c("view-track-bar", {
        ref: "viewTrack",
        staticClass: "track-bar",
        style: _vm.trackBarStyleTime,
        attrs: { "track-menu": _vm.trackMenu },
        on: { trackClick: _vm.trackClick },
      }),
      _vm.chart.type && _vm.antVRenderStatus
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.title_show,
                  expression: "title_show",
                },
              ],
              ref: "title",
              staticStyle: { cursor: "default", display: "block" },
              style: _vm.title_class,
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "4px 4px 0", margin: "0" } },
                [
                  _c("chart-title-update", {
                    attrs: {
                      "title-class": _vm.title_class,
                      "chart-info": _vm.chartInfo,
                    },
                  }),
                  _vm.remarkCfg.show
                    ? _c("title-remark", {
                        staticStyle: {
                          "text-shadow": "none!important",
                          "margin-left": "4px",
                        },
                        attrs: { "remark-cfg": _vm.remarkCfg },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("div", {
        staticStyle: { width: "100%", overflow: "hidden" },
        style: { height: _vm.chartHeight },
        attrs: { id: _vm.chartId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }